<template>
	<div>
		<h4 class="mb-4 font-weight-bold text-center">Report Date</h4>
		<div
			v-if="dateBadges.length"
			class="mb-4 d-flex align-items-center justify-content-center"
		>
			<b-form-checkbox
				v-for="dateBadge in dateBadges"
				v-model="innerValue"
				@change="onChange"
				:key="dateBadge"
				:value="dateBadge"
				class="mx-2 mb-2"
			>
				{{ dateBadge }}
			</b-form-checkbox>
		</div>

		<div class="date-period-options mx-auto">
			<b-form-group v-slot="{ ariaDescribedby }">
				<b-form-radio-group
					v-model="innerValue"
					@change="onChange"
					:options="dateOptions"
					:aria-describedby="ariaDescribedby"
					stacked
				></b-form-radio-group>
			</b-form-group>

			<b-row v-if="'custom' === innerValue">
				<b-col cols="6">
					<label for="report-date-from" class="small"
						>Report Date From</label
					>
					<DatePicker
						v-model="dateFrom"
						:disabled-date="disabledFromDates"
						format="MM-DD-YYYY"
						value-type="format"
						input-class="form-control form-control-sm"
						:input-attr="{ id: 'report-date-from' }"
						class="w-100 d-block"
					/>
				</b-col>
				<b-col cols="6">
					<label for="report-date-to" class="small"
						>Report Date To</label
					>
					<DatePicker
						v-model="dateTo"
						:disabled-date="disabledToDates"
						:input-attr="{ id: 'report-date-to' }"
						format="MM-DD-YYYY"
						value-type="format"
						input-class="form-control form-control-sm"
						class="w-100 d-block"
					/>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import "vue2-datepicker/index.css";

import moment from "moment";
import DatePicker from "vue2-datepicker";

export default {
	components: {
		DatePicker,
	},
	props: {
		value: [String, Array, Object],
		dateBadges: Array,
		exclude: Array,
	},
	data() {
		return {
			innerValue: null,
			dateFrom: null,
			dateTo: null,
		};
	},
	computed: {
		dateOptions() {
			return [
				{ value: null, text: "All" },
				{
					value: "prev-month",
					text: "Last Month",
				},
				{
					value: "current-month",
					text: "This Month",
				},
				{ value: "custom", text: "Custom" },
			].map((item) => {
				item.disabled = this.exclude.includes(item.value);

				return item;
			});
		},
	},
	methods: {
		disabledFromDates(date, value) {
			const startMonth = moment().startOf("month");
			const endMonth = moment().endOf("month");

			let isDisabled = false;

			this.dateOptions
				.filter(
					(item) =>
						["prev-month", "current-month"].includes(item.value) &&
						item.disabled
				)
				.forEach((item) => {
					if ("prev-month" === item.value) {
						startMonth.subtract(1, "month");
						endMonth.subtract(1, "month");
					}

					isDisabled =
						startMonth.toDate().getTime() <= date.getTime() &&
						endMonth.toDate().getTime() >= date.getTime();
				});

			return isDisabled;
		},
		disabledToDates(date, value) {
			const startMonth = moment().startOf("month");
			const endMonth = moment().endOf("month");

			let isDisabled = false;

			this.dateOptions
				.filter(
					(item) =>
						["prev-month", "current-month"].includes(item.value) &&
						item.disabled
				)
				.forEach((item) => {
					if ("prev-month" === item.value) {
						startMonth.subtract(1, "month");
						endMonth.subtract(1, "month");
					}

					isDisabled =
						startMonth.toDate().getTime() <= date.getTime() &&
						endMonth.toDate().getTime() >= date.getTime();
				});

			if (this.dateFrom)
				isDisabled =
					date.getTime() <
					moment(this.dateFrom, "MMDDYYYY").valueOf();

			return isDisabled;
		},
		onChange(value) {
			const startMonth = moment().startOf("month");
			const endMonth = moment().endOf("month");

			if (Array.isArray(value)) {
				this.$emit("input", value.length ? value : null);
			} else {
				if (null === value) {
					this.$emit("input", null);
				} else if ("prev-month" === value) {
					this.dateFrom = startMonth
						.subtract(1, "month")
						.format("MM-DD-YYYY");
					this.dateTo = endMonth
						.subtract(1, "month")
						.format("MM-DD-YYYY");
				} else if ("current-month" === value) {
					this.dateFrom = startMonth.format("MM-DD-YYYY");
					this.dateTo = endMonth.format("MM-DD-YYYY");
				}
			}
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(newVal) {
				if (!newVal || Array.isArray(newVal)) {
					this.innerValue = newVal || null;

					return false;
				}

				const startMonth = moment().startOf("month");
				const endMonth = moment().endOf("month");

				this.dateFrom = newVal.from;
				this.dateTo = newVal.to;

				if (
					this.dateFrom === startMonth.format("MM-DD-YYYY") &&
					this.dateTo === endMonth.format("MM-DD-YYYY")
				)
					this.innerValue = "current-month";
				else if (
					this.dateFrom ===
						startMonth.subtract(1, "month").format("MM-DD-YYYY") &&
					this.dateTo ===
						endMonth.subtract(1, "month").format("MM-DD-YYYY")
				)
					this.innerValue = "prev-month";
				else this.innerValue = "custom";
			},
		},
		dateFrom(newVal) {
			if (!newVal && !this.dateFrom) return;

			this.$emit("input", {
				from: newVal,
				to: this.dateTo,
			});
		},
		dateTo(newVal) {
			if (!this.dateFrom) return;

			this.$emit("input", {
				from: this.dateFrom,
				to: newVal,
			});
		},
	},
};
</script>

<style lang="scss">
.date-period-options {
	max-width: 400px;

	.mx-datepicker input {
		border-radius: 30px;
	}
}
</style>
